import React, { Component } from 'react';
import CalendarIntegrations from 'components/shared/integrations/CalendarIntegrations';
import AvailabilitiesForm from 'components/landlord_app/community/AvailabilitiesForm/AvailabilitiesForm';

class UserShowingsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBookingPreferences: props.availability,
    };
  }

  showPreferencesAndResizeWindow = (e, value) => {
    this.setState({ showBookingPreferences: value });
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  };

  render() {
    if (!this.state.showBookingPreferences) return null;
    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <CalendarIntegrations />
        {this._renderAvailabilitiesForm()}
      </div>
    );
  }

  _renderAvailabilitiesForm = () => {
    if (!this.props.showAvailabilitiesForm) return;
    if (!this.props.availability.availabilities) return;

    return (
      <AvailabilitiesForm
        weekData={this.props.availability.availabilities}
        submitAvailability={this.props.submitAvailability}
      />
    );
  };
}

export default UserShowingsForm;
